import { InputAttributes, NumericFormat } from 'react-number-format';
import styled, { css } from 'styled-components';

import { fontSizes, fontWeights, Theme } from '../../../../theme';
import { ElementSize } from '../../../../types';
import mapInputSizeToThemeSize from '../../../Input/utils/mapInputSizeToThemeSize';
import { NumericInputClassNames } from '../../constants';

const getFontStyles = (theme: Theme, size: ElementSize) => css`
  line-height: ${theme.core.iconSize.m};
  font-weight: ${fontWeights.regular};
  font-size: ${size === 'small' ? fontSizes.xs : fontSizes.m};
`;

export const NumericInputElementWrapper = styled.div<{ $size: ElementSize }>`
  box-sizing: border-box;
  position: relative;
  background: inherit;
  color: inherit;
  padding: 0;
  width: 100%;

  &:focus-within {
    .${NumericInputClassNames.Mask} {
      display: none;
    }
  }
`;

export const NumericInputElement = styled(NumericFormat<InputAttributes>)<{
  $size: ElementSize;
}>`
  ${({ theme, $size, disabled }) => css`
    box-sizing: border-box;
    width: 100%;
    padding: 0;

    ${getFontStyles(theme, $size)}

    background: inherit;
    color: inherit;
    border: none;
    outline: none;
    box-shadow: none;

    cursor: ${disabled && 'not-allowed'};
    caret-color: currentcolor;

    &::placeholder {
      color: ${theme.components.Input.placeholder[
        mapInputSizeToThemeSize($size)
      ]['fg-default']};
    }
  `}
`;

export const NumberInputMask = styled.span<{
  $size: ElementSize;
  $isDisabled: boolean;
}>`
  ${({ theme, $size, $isDisabled }) => css`
    box-sizing: border-box;
    display: block;
    position: absolute;
    inset: 0;
    overflow: hidden;
    background: inherit;
    color: inherit;

    ${getFontStyles(theme, $size)}

    border: none;
    cursor: ${$isDisabled && 'not-allowed'};
    pointer-events: none;
  `}
`;
